class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    // this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

//TODO - when menu isn't open, no animation
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.hoverEnabled =
      document.querySelectorAll('header[data-hover="true"]').length > 0;
    this.header = document.querySelector(".header-wrapper");
    this.links = document.querySelector(".header__inline-menu");

    this.background = this.querySelector(".mega-menu__bg");

    if (this.hoverEnabled) {
      this.mainDetailsToggle.addEventListener(
        "mouseenter",
        this.onToggleHover.bind(this),
      );
      this.links.addEventListener("mouseleave", this.close.bind(this));
      this.background.addEventListener("mouseenter", this.close.bind(this));
    }
  }

  onToggleHover() {
    this.closeAllMenus();
    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", true);

    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  closeAllMenus() {
    //close others
    var open_menus = document.querySelectorAll(
      "header-menu:has(details[open])",
    );
    open_menus.forEach((el) => {
      el.close();
    });
  }
}

customElements.define("header-menu", HeaderMenu);

